import { HttpClient } from '@/shared/lib/http-client';

export const fetchCurrentUser = async () => {
  const response = await HttpClient.get('/auth/user', {});
  return response.data?.data;
};
